// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class CommitteeTypeExtras {
    public static readonly ALLHOUSEDISTRICTS: number = -1;
    public static readonly ALLSENATEDISTRICTS: number = -2;
}
